/**
 * Próximo feriado/evento (o el que está en curso hoy) para mostrar como aviso arriba
 * del widget de Calendario. Lógica pura, sin dependencias de React, para poder
 * testear la selección de fecha sin renderizar el componente.
 */
import { MONTH_NAMES_ES } from './dateBucketFormat';

function eventStart(ev) {
  return ev.startDate || ev.date || '';
}
function eventEnd(ev) {
  return ev.endDate || ev.date || ev.startDate || '';
}

/**
 * events: la lista completa de chart.calendarEvents (de cualquier mes, no solo el que
 * esté navegando el widget). todayStr: "yyyy-mm-dd".
 * Devuelve { ongoing, upcoming }: el evento en curso hoy (si hay uno) y el próximo
 * evento futuro más cercano (si hay uno), cada uno con su startDate/endDate ya
 * normalizados. Cualquiera de los dos puede ser null.
 */
export function resolveNextOrOngoingEvent(events, todayStr) {
  const list = Array.isArray(events) ? events : [];
  let ongoing = null;
  let upcoming = null;
  list.forEach((ev) => {
    const start = eventStart(ev);
    const end = eventEnd(ev);
    if (!start) return;
    const normalized = { ...ev, startDate: start, endDate: end };
    if (start <= todayStr && todayStr <= end) {
      if (!ongoing || start < ongoing.startDate) ongoing = normalized;
    } else if (start > todayStr) {
      if (!upcoming || start < upcoming.startDate) upcoming = normalized;
    }
  });
  return { ongoing, upcoming };
}

/** "yyyy-mm-dd" -> "18 de septiembre" (sin año; se asume el mismo año o "el próximo"). */
export function formatFriendlyDate(dateStr) {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(dateStr || '');
  if (!match) return dateStr || '';
  const day = parseInt(match[3], 10);
  const monthIndex1 = parseInt(match[2], 10);
  const monthName = MONTH_NAMES_ES[monthIndex1];
  return monthName ? `${day} de ${monthName.toLowerCase()}` : dateStr;
}
